import { SITE_METADATA } from '~/data/site-metadata'

type ImageSize = 'thumbnail' | 'mobile' | 'tablet' | 'desktop'
type ImageFormat = 'webp' | 'jpg' | 'png' | 'avif'

interface ImageOptions {
  quality?: number // Chất lượng ảnh (0-100)
  width?: number // Chiều rộng tùy chỉnh
  format?: ImageFormat // Định dạng ảnh
  priority?: boolean // Ảnh ưu tiên tải nhanh
}

const SIZE_PRESETS: Record<ImageSize, { width: number; quality: number }> = {
  thumbnail: { width: 300, quality: 60 },
  mobile: { width: 640, quality: 65 },
  tablet: { width: 1024, quality: 75 },
  desktop: { width: 1920, quality: 85 },
}

export const getImageUrlCrs = (
  url: string,
  size: ImageSize = 'tablet',
  options: ImageOptions = {
    priority: true,
  }
): string => {
  const preset = SIZE_PRESETS[size]
  // Ưu tiên width từ options, nếu không có thì dùng preset
  const width = options.width || preset?.width

  // Ưu tiên quality từ options, nếu không có thì dùng preset
  // Nếu là ảnh ưu tiên, tăng chất lượng thêm 10 (max 100)
  let quality = options.quality || preset?.quality
  if (options.priority) {
    quality = Math.min(quality + 10, 100)
  }

  const params = new URLSearchParams()
  params.append('width', width.toString())
  params.append('quality', quality.toString())
  params.append('format', options.format || 'webp')

  // Get image_id from the last segment of the URL
  // const urlSegments = url.split('/')
  // const image_id = urlSegments[urlSegments.length - 1]

  // Construct new URL with /assets/ path
  // const newUrl = `${CMS_URL}/assets/${image_id}`
  // return `${newUrl}?${params.toString()}`
  return `${url}`
}

// Helper functions cho các trường hợp phổ biến
export const getResponsiveImageUrl = (imageId: string, format?: ImageFormat) =>
  getImageUrlCrs(imageId, 'desktop', { format })

export const getHighQualityImageUrl = (imageId: string, format?: ImageFormat) =>
  getImageUrlCrs(imageId, 'desktop', { priority: true, format })

export const getThumbnailUrl = (imageId: string, format?: ImageFormat) =>
  getImageUrlCrs(imageId, 'thumbnail', { format })
